import React, { useMemo } from "react";
import { Button, Stack } from "@mui/joy";
import DefaultPage from "pages/container/DefaultPage";
import distancingLogo from "static/image/common/distancing_logo.png";
import CustomTypography from "../../common/CustomTypography";
import { theme } from "../../../styles/theme";
import { useRecoilValue } from "recoil";
import { userSimpleAtom } from "../../../recoil/userSimpleAtom";
import { isDev } from "../../../config";
import useAutoLoginPromotion from "../../../hooks/useAutoLoginPromotion";
import { buildResumeInstallDeepLink } from "data/deepLinkData";

export default function PromotionCompleted() {
  useAutoLoginPromotion();
  const user = useRecoilValue(userSimpleAtom);

  const loginMessage = useMemo(() => {
    const authType = user?.authenticateType?.toLowerCase();
    if (authType === "apple") {
      return "설치 후 'Apple로 시작하기'로 로그인해주세요.";
    } else if (authType === "google") {
      return "설치 후 'Google로 시작하기'로 로그인해주세요.";
    } else if (authType === "kakao") {
      return "설치 후 'Kakao로 시작하기'로 로그인해주세요.";
    } else {
      return null;
    }
  }, [user?.authenticateType]);

  return (
    <DefaultPage
      backgroundColor={theme.vars.palette.Background.Level3}
      content={
        <Stack alignItems="center" spacing={5}>
          <Stack spacing={4} alignItems={"center"}>
            <img
              src={distancingLogo}
              alt="distancing logo"
              style={{ width: "138px", height: "auto" }}
            />
            <CustomTypography
              variant={"Subtitle"}
              sx={{
                textAlign: "center",
                color: theme.vars.palette.Content.Strong,
                fontWeight: 500,
              }}
            >
              {"모든 준비가 끝났어요.\n" +
                "이제 앱에서 프로그램을 시작해주세요."}
            </CustomTypography>
          </Stack>
          <Stack spacing={1.5} alignItems={"center"} sx={{ width: "100%" }}>
            <Button
              onClick={() => {
                window.open(
                  buildResumeInstallDeepLink(isDev, user?.authenticateType),
                  "_blank"
                );
              }}
              variant={"Solid"}
              color={"primary"}
              size={"lg"}
              sx={{
                width: "100%",
                maxWidth: "345px",
                height: "54px",
                fontWeight: 700,
                borderRadius: "12px",
                fontSize: "16px",
              }}
            >
              {"앱 설치하기"}
            </Button>

            {loginMessage && (
              <CustomTypography
                variant={"Caption"}
                sx={{
                  textAlign: "center",
                  color: theme.vars.palette.Content.Weak,
                  fontWeight: 500,
                }}
              >
                {loginMessage}
              </CustomTypography>
            )}
          </Stack>
        </Stack>
      }
    />
  );
}
